import { createContext, useContext } from "react";

export const UserDrm = createContext({
    matchRights: (() => false),
    drm: { list: [], map: {} }
});

export function useUserDrm() {
    return useContext(UserDrm);
};